import { create } from 'zustand'

export const useProgramStore = create<{
  entityId: string | null
  hasEntity: boolean
  isOwner: boolean
  periode: [string, string]
  setProgram: (param: {
    isOwner: boolean
    periode: [string, string]
    entityId?: string
  }) => void
}>((set) => ({
  entityId: null,
  hasEntity: false,
  isOwner: false,
  periode: ['', ''],
  setProgram: ({
    entityId,
    isOwner,
    periode,
  }: {
    entityId?: string
    isOwner: boolean
    periode: [string, string]
  }) =>
    set({
      entityId: Boolean(Number(entityId)) ? entityId : null,
      hasEntity: Boolean(Number(entityId)),
      periode,
      isOwner,
    }),
}))
